(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["al-product-specs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('al-product-specs')) {
    customElements.define('al-product-specs', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[data-section-type="product-page-section"]') || this.closest('form') || this.parentElement;
        this.templates = Array.from(this.querySelectorAll('template[data-spec-variant]'));
        this.display = this.querySelector('[data-spec-display]');
        this.unavailable = this.querySelector('[data-spec-unavailable]');
        this.changeHandler = (event) => {
          if (event.target.matches('.single-option-selector, [name="id"], input[type="radio"]')) {
            requestAnimationFrame(() => this.update(event.target.name === 'id'));
          }
        };
        this.popHandler = () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          if (id) this.show(this.templates.find(item => item.dataset.specVariant === id));
        };
        this.scope.addEventListener('change', this.changeHandler);
        window.addEventListener('popstate', this.popHandler);
      }
      disconnectedCallback() {
        this.scope.removeEventListener('change', this.changeHandler);
        window.removeEventListener('popstate', this.popHandler);
      }
      update(useMaster) {
        const options = Array.from(this.scope.querySelectorAll('select.single-option-selector')).map(input => input.value);
        const master = this.scope.querySelector('select[name="id"], input[name="id"]');
        let selected;
        if (!useMaster && options.length) {
          selected = this.templates.find(item => JSON.stringify(JSON.parse(item.dataset.options)) === JSON.stringify(options));
        } else if (master) {
          selected = this.templates.find(item => item.dataset.specVariant === master.value);
        }
        this.show(selected);
      }
      show(selected) {
        this.display.hidden = !selected;
        this.unavailable.hidden = !!selected;
        if (selected) this.display.replaceChildren(selected.content.cloneNode(true));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
